class stainGridJS {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle dynamically loaded content from pagination
    document.addEventListener('change', (event) => {
      // Check if the changed element is a stain checkbox
      if (event.target.matches('input[type="checkbox"][data-stain-feature]')) {
        this.handleStainChange(event);
      }
    });
  }

  handleStainChange(event) {
    const selectedStain = event.target;
    if (!selectedStain) return;
    const stainFeature = selectedStain.getAttribute('data-stain-feature');
    // if (!stainFeature) return;
    const parentContainer = selectedStain.closest('[data-product-grid]');
    if (!parentContainer) return;

    // First, uncheck all other stain checkboxes in this container to ensure only one is selected
    parentContainer.querySelectorAll("[data-stain-feature]").forEach(ele => {
      if (ele !== selectedStain) {
        ele.checked = false;
      }
    });

    // If the current checkbox is being unchecked, reset to default state
    if (!selectedStain.checked) {
      let priceEle = parentContainer.querySelector('[data-origional-price]');
      let price = parseFloat(priceEle.getAttribute('data-origional-price').replace(/,/g, '')) || 0;
      priceEle.textContent = this.formatMoney(price);
      let comparePriceEle = parentContainer.querySelector('[data-comapare-price]');
      if (comparePriceEle) {
        let comparePrice = parseFloat(comparePriceEle.getAttribute('data-comapare-price').replace(/,/g, '')) || 0;
        comparePriceEle.textContent = this.formatMoney(comparePrice);
      }
      parentContainer.querySelectorAll("[data-product-url]").forEach(el => {
        const productUrl = el.getAttribute('data-product-url');
        if (productUrl) el.href = productUrl;
      });
      parentContainer.querySelectorAll('[data-image-type]').forEach(card=>{
        card.classList.add("d-none");
      });
      parentContainer.querySelectorAll('[data-image-type]')[0].classList.remove("d-none");
      return;
    }
    const cards = parentContainer.querySelectorAll('[data-image-type]');
    if (!cards.length) return;
    const featureToMatch = stainFeature.toLowerCase();
    let hasVisibleCard = false;
    cards.forEach(card => {
      const stainType = card.getAttribute('data-image-type');
      if (!stainType) return;
      const stain = stainType.toLowerCase();
      const matches = stain.includes(featureToMatch);
      card.classList.toggle('d-none', !matches);
      if (matches) hasVisibleCard = true;
    });

    // Show fallback main image if no match found
    if (!hasVisibleCard) {
      const fallback = parentContainer.querySelector('[data-image-type="main"]');
      if (fallback) fallback.classList.remove('d-none');
    }
    this.calculatePrice(parentContainer);
  }

  calculatePrice(parentContainer) {
    const priceElement = parentContainer.querySelector('[data-origional-price]');
    const comparePriceElement = parentContainer.querySelector('[data-comapare-price]');
    if (!priceElement) return;
    const selectedStain = parentContainer.querySelector('input[type="checkbox"][data-stain-feature]:checked');
    if (!selectedStain) return;
    let selectedStainValue = selectedStain.getAttribute('data-stain-feature');
    const stainPrice = parseFloat(selectedStain.getAttribute('data-price').replace(/,/g, '')) || 0;
    const stainQty = parseFloat(selectedStain.getAttribute('data-stain-qty').replace(/,/g, '')) || 0;
    const stainComparePrice = parseFloat(selectedStain.getAttribute('data-compare-price').replace(/,/g, '')) || 0;
    const basePrice = parseFloat(priceElement.getAttribute('data-origional-price').replace(/,/g, '')) || 0;
    const comparePrice = parseFloat(comparePriceElement?.getAttribute('data-comapare-price').replace(/,/g, '')) || 0;
    const stainTotalPrice = stainPrice * stainQty
    const totalPrice = basePrice + stainTotalPrice;
    const totalComparePrice = stainComparePrice + comparePrice;
    if(priceElement) priceElement.textContent = this.formatMoney(totalPrice);
    if(comparePriceElement) comparePriceElement.textContent = this.formatMoney(totalComparePrice);
    parentContainer.querySelectorAll("[data-product-url]").forEach(url => {
      let productUrl = url.getAttribute('data-product-url');
      if (productUrl) {
        url.href = productUrl + `?stain=${selectedStainValue}`;
      }
    });
  }

  formatMoney(amount) {
    // Format money to match Shopify's money format
    // This will show whole numbers without decimals when appropriate
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  }
}

new stainGridJS();
